import { useEffect } from 'react';

export const useAnimateOnScroll = (options) => {
    useEffect(() => {
      // Select all elements with "animate__animated" class
      const elements = document.querySelectorAll(".animate__animated");
  
      // Set elements to hidden by default
      elements.forEach((element) => {
        element.style.visibility = "hidden";
      });
  
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const element = entry.target;
  
              // Find all animate.css animation classes dynamically
              const animationClasses = Array.from(element.classList).filter((cls) =>
                cls.startsWith("animate__")
              );
  
              // Set element to visible
              element.style.visibility = "visible";
  
              // Remove all animation classes to reset
              element.classList.remove("animate__animated", ...animationClasses);
              void element.offsetWidth; // Trigger reflow to restart animation
              // Re-add the animation classes
              element.classList.add("animate__animated", ...animationClasses);
  
              // Stop observing the element after the animation is triggered
              observer.unobserve(element);
            }
          });
        },
        {
          threshold: 0.1, // Trigger when 10% of the element is visible
          ...options,
        }
      );
  
      // Observe each element
      elements.forEach((element) => observer.observe(element));
    }, [options]);
  };
  
